.container {
  overflow: hidden;
}

.list {
  display: flex;
  gap: 8px;
  height: 94px;
  overflow-x: scroll;
  scroll-behavior: smooth;
  transition: all 0.6s cubic-bezier(0.51, 0.94, 0.58, 1);

  &::-webkit-scrollbar {
    display: none;
  }
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    gap: 10px;

    /* スクロール用のボタンなどの UI のみからスクロール可能にする */
    height: 118px;

    /* スクロールによる擬似的なページングの最終ページで、画像を左に揃えるための右側の余白 */
    padding-right: 742px;
    overflow-x: visible;
  }

  .list2015 {
    padding-right: 718px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    gap: 10px;

    /* スクロール用のボタンなどの UI のみからスクロール可能にする */
    height: 118px;

    /* スクロールによる擬似的なページングの最終ページで、画像を左に揃えるための右側の余白 */
    padding-right: 742px;
    overflow-x: visible;
  }

  .list2015 {
    padding-right: 718px;
  }
}
